import { render } from "./Botao.vue?vue&type=template&id=9ebd1aea&ts=true"
import script from "./Botao.vue?vue&type=script&lang=ts"
export * from "./Botao.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__